import client from './client';

export interface InspectIssue {
  severity: 'high' | 'medium' | 'low';
  title: string;
  detail: string;
}

export interface InspectReport {
  ok: boolean;
  aiUsed: boolean;
  model: string | null;
  summary: string;
  issues: InspectIssue[];
  suggestions: string[];
  imageCount: number;
  durationMs: number;
}

export async function postRenderInspect(body: {
  images: Array<{ name?: string; dataUrl?: string; url?: string }>;
  context?: { sceneName?: string; prompt?: string };
}): Promise<InspectReport> {
  // 视觉模型最长等待 60s（服务端超时后降级），客户端超时需大于该值
  const { data } = await client.post('/render-inspect/report', body, { timeout: 120_000 });
  return data;
}
